import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 16px;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    h3 {
      margin: 0 !important;
    }

    img {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    .close-button {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 44px;
      min-height: 44px;
      padding: 0;
      border: none;
      background: none;
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
        opacity: 0.4;

        img {
          cursor: not-allowed;
        }
      }

      &:focus-visible {
        outline: 2px solid ${ ({ theme }) => theme.colors.primary };
        outline-offset: 2px;
      }
    }

    .hidden { 
      visibility: hidden;
    }
  }

  .cards-container {
    display: flex;
    flex-direction: row;
    white-space: pre-wrap;
    align-items: center;
    margin: 0 0 16px;
    
    .active-card {
      font-weight: 600;
      font-size: 17px;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      &-info {
        font-weight: normal;
        font-size: 15px;
        cursor: pointer;
      }
    }

    .new-card {
      font-size: 17px;
      font-weight: 600;
      cursor: pointer;
    }
  }

  .option-text {
    text-align: center;
    font-size: 16px;
  }

`
